import React, { useState, useEffect } from 'react';
import '../styles/loadingBar.scss';

const LoadingBar = () => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let interval = null;

    const handleLoadingStart = () => {
      setIsVisible(true);
      setProgress(0);
      
      let currentProgress = 0;
      interval = setInterval(() => {
        currentProgress += Math.random() * 15;
        if (currentProgress > 85) {
          currentProgress = 85;
          clearInterval(interval);
        }
        setProgress(currentProgress);
      }, 150);
    };

    const handleLoadingComplete = () => {
      if (interval) {
        clearInterval(interval);
      }
      setProgress(100);
      setTimeout(() => {
        setIsVisible(false);
        setProgress(0);
      }, 300);
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('loadingStart', handleLoadingStart);
      window.addEventListener('loadingComplete', handleLoadingComplete);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
      if (typeof window !== 'undefined') {
        window.removeEventListener('loadingStart', handleLoadingStart);
        window.removeEventListener('loadingComplete', handleLoadingComplete);
      }
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="loading-bar-container">
      <div 
        className="loading-bar" 
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default LoadingBar;
